import {gql} from "@apollo/client";

export const getDiseasesQuery = gql`
  query getDiseases($clientId: ID!) {
    diseases( clientId: $clientId) {id, name, chronic, details}
  }
`;

export const createDiseaseMutation = gql`
  mutation createDisease($name: String!, $details: String, $chronic: String, $clientId: ID!){
    createDisease(
      input: {
        name: $name,
        details: $details,
        clientId: $clientId,
        chronic: $chronic
      }) {
      disease {
        id
      }
    }
  }
`

export const deleteDiseaseMutation = gql`
  mutation deleteDisease($id: ID!){
    deleteDisease(
      input: {id: $id}) {
      disease {
        id
      }
    }
  }
`